import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { ScheduleContainer } from '../../models/appcloud/schedule-container.model';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { HttpHeaderConstants } from '../http-header.constant';
import { SpinnerService } from '../spinner';

@Injectable({
    providedIn: 'root',
})
export class ScheduleContainerService {
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);
    readonly #errorHandlingService = inject(ErrorHandlingService);

    private SCHEDULE_CONTAINER_URL = environment.publicApiHost + '/appcloud/schedule-containers';

    public get(id: number, additionalHeaders: any = {}): Observable<ScheduleContainer> {
        this.#spinnerService.addProcess('ScheduleContainerService.get.' + id, 'Retrieving your schedule...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };

        return this.#http.get<ScheduleContainer>(this.SCHEDULE_CONTAINER_URL + '/' + id, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while retrieving your schedule. Please try again later.'
                );
                return of<ScheduleContainer>();
            }),
            finalize(() => this.#spinnerService.completeProcess('ScheduleContainerService.get.' + id))
        );
    }

    public upsert(scheduleContainer: ScheduleContainer, additionalHeaders: any = {}): Observable<ScheduleContainer> {
        this.#spinnerService.addProcess(
            'ScheduleContainerService.create.' + scheduleContainer.eloquainstallId,
            'Scheduling run...'
        );
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
        };

        return this.#http.post<ScheduleContainer>(this.SCHEDULE_CONTAINER_URL, scheduleContainer, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while scheduling your import run. Please try again later.'
                );
                return of<ScheduleContainer>();
            }),
            finalize(() =>
                this.#spinnerService.completeProcess(
                    'ScheduleContainerService.create.' + scheduleContainer.eloquainstallId
                )
            )
        );
    }
}
